import { AddressSelectionPage } from '@/app/pages/AddressSelectionPage';

export function ResponsiveAddressSelectionPage() {
  return <AddressSelectionPage />;
}
